import './asset-search.scss';
import {
    getOffset,
    smoothScrollTo,
    containerSmoothScrollTo,
    serializeForm,
    createElementFromHTML
} from '../../js/helper';
import { AjaxLoader } from '../../js/ajax-loader';
import { Slider } from '../../components/slider/slider';

class AssetSearch {
    constructor (element) {
        this.$assetSearch = element;
        this.$form = this.$assetSearch.querySelector('form');
        this.$target = this.$assetSearch.querySelector('[data-asset-search="target"]');
        this.$siteHeader = document.querySelector('[data-header="root"]');
        this.resultsTarget = this.$assetSearch.querySelector('[data-asset-search="results"]');
        this.$topContent = this.$assetSearch.querySelector('[data-asset-search="topcontent"]');
        this.$backButton = this.$assetSearch.querySelector('[data-asset-search="back"]');
        this.$searchInput = this.$assetSearch.querySelector('[data-asset-search="query"]');
        this.$searchSubmit = this.$assetSearch.querySelector('[data-asset-search="query-submit"]');
        this.$assetSearchSearch = this.$assetSearch.querySelector('[data-asset-search="search"]');
        this.$searchInputClear = this.$assetSearchSearch.querySelector('[data-asset-search="delete"]');
        this.$sidebar = this.$assetSearch.querySelector('[data-asset-search-sidebar]');
        this.$sidebarScroller = this.$sidebar.querySelector('[data-scroller="scroller"]');
        this.$$catFilterScroller = null;
        this.$sidebarToggleButton = this.$assetSearch.querySelector('[data-asset-search="sidebar-toggle-button"]');
        this.$sidebar = {};
        this.$results = {};
        this.$$categoryHeadlines = {};
        this.$$radioFilter = {};
        this.$$sidebarFilter = {};
        this.maxCategories = 5;
        this.headlineObserver = null;
        this.allowSubmit = true;
        this.slidersActive = false;
        this.$activePreFilter = null;
        this.$addToBasketInput = document.querySelector('[data-assets-search-add-to-basket]');
        this.$toBasketInput = document.querySelector('#sub-nav_toggle-basket');

        this.localStorage = [];

        this.sliders = [];
    }

    initialize () {
        this.setEvents();
        this.checkActivePreFilter();
        this.initResultEvents();
        this.setScrollerEvents();
        this.initCatFilterScroller();
        this.initPreFilterScroller();
        this.storage().get();
    }

    setEvents () {
        window.resizeHandler.customFunctions.push(() => {
            if (window.innerWidth >= 1024) {
                this.$target.classList.add('has--no-transition');
                if (this.slidersActive) {
                    this.destroySlider();
                }
            } else {
                if (this.slidersActive === false) {
                    this.createSlider();
                }

                this.$$catFilterScroller.forEach(($catScroller) => {
                    this.checkScrollerPosition($catScroller);

                    $catScroller.addEventListener('scroll', () => {
                        this.checkScrollerPosition($catScroller);
                    });
                });
            }
        });

        this.$searchSubmit.addEventListener('click', (e) => {
            if (window.innerWidth < 1024) {
                if (!this.$assetSearchSearch.classList.contains('is--active')) {
                    this.$assetSearchSearch.classList.add('is--active');
                } else {
                    this.$assetSearchSearch.classList.remove('is--active');
                }
            }
        });

        this.$searchInputClear.addEventListener('click', () => {
            this.$searchInput.value = '';
        });
    }

    initCatFilterScroller () {
        this.$$catFilterScroller = this.$topContent.querySelectorAll('[data-scroller="scroller"]');

        this.$$catFilterScroller.forEach(($catScroller) => {
            this.checkScrollerPosition($catScroller);

            $catScroller.addEventListener('scroll', () => {
                this.checkScrollerPosition($catScroller);
            });
        });
    }

    initPreFilterScroller () {
        this.checkScrollerPosition(this.$sidebarScroller);

        this.$sidebarScroller.addEventListener('scroll', () => {
            this.checkScrollerPosition(this.$sidebarScroller);
        });
    }

    checkScrollerPosition ($scroller) {
        const $scrollPrev = $scroller.parentNode.querySelector('[data-scroller="prev"]');
        const $scrollNext = $scroller.parentNode.querySelector('[data-scroller="next"]');

        if ($scroller.scrollLeft <= 0) {
            $scrollPrev.classList.add('is--hidden');
        } else {
            $scrollPrev.classList.remove('is--hidden');
        }

        if ($scroller.scrollLeft + $scroller.clientWidth >= $scroller.scrollWidth) {
            $scrollNext.classList.add('is--hidden');
        } else {
            $scrollNext.classList.remove('is--hidden');
        }
    }

    checkActivePreFilter () {
        this.$activePreFilter = this.$assetSearch.querySelector('input[data-asset-search="prefilter"]:checked');
    }

    setScrollerEvents () {
        this.$$scrollPrevs = this.$assetSearch.querySelectorAll('[data-scroller="prev"]');
        this.$$scrollNexts = this.$assetSearch.querySelectorAll('[data-scroller="next"]');

        if (this.$$scrollPrevs.length > 0) {
            this.$$scrollPrevs.forEach(($prev) => {
                $prev.addEventListener('click', () => {
                    const $scroller = $prev.parentNode?.querySelector('[data-scroller="scroller"]');

                    findNextElement($scroller, 'prev');
                });
            });
        }

        if (this.$$scrollNexts.length > 0) {
            this.$$scrollNexts.forEach(($next) => {
                $next.addEventListener('click', () => {
                    const $scroller = $next.parentNode?.querySelector('[data-scroller="scroller"]');
                    findNextElement($scroller, 'next');
                });
            });
        }

        const findNextElement = ($scroller, direction) => {
            if ($scroller) {
                let firstVisibleElement = null;
                const $$inputs = $scroller.querySelectorAll('input[type="radio"]');
                const left = parseInt(window.getComputedStyle($scroller.firstElementChild, null).getPropertyValue('padding-left'));

                for (let i = 0; i < $$inputs.length; i++) {
                    if (($$inputs[i].offsetLeft - left) >= $scroller.scrollLeft) {
                        firstVisibleElement = $$inputs[i];
                        break;
                    }
                }

                if (firstVisibleElement) {
                    let $nextInput = null;

                    if (direction === 'prev') {
                        $nextInput = firstVisibleElement.parentNode.previousElementSibling?.querySelector('input[type="radio"]');
                    }

                    if (direction === 'next') {
                        $nextInput = firstVisibleElement.parentNode?.nextElementSibling?.querySelector('input[type="radio"]');
                    }

                    if ($nextInput) {
                        this.changeScrollerPosition($scroller, $nextInput);
                    }
                }
            }
        };
    }

    changeScrollerPosition ($scroller, $element) {
        const left = Math.round(parseFloat(window.getComputedStyle($scroller.firstElementChild, null).getPropertyValue('padding-left')));
        containerSmoothScrollTo($scroller, $element.offsetLeft - Math.ceil(left), 0, 250);
    }

    initSlider (slider, index) {
        this.sliders[index] = new Slider(slider, {
            speed: 500,
            indicators: true,
            prevnext: true,
            slidesPerView: 'auto',
            resistance: true,
            resistanceRatio: 0,
            initAttr: 'data-asset-search',
            breakpoints: {
                1024: {
                    slidesPerView: 2
                },
                1440: {
                    slidesPerView: 3
                }
            }
        });
    }

    createSlider () {
        if (this.$$slider.length > 0 && window.innerWidth < 1024) {
            this.$$slider.forEach((slider, index) => {
                this.initSlider(slider, index);
            });
            this.slidersActive = true;
        }
    }

    destroySlider () {
        if (this.sliders.length > 0) {
            for (let index = 0; index < this.sliders.length; index++) {
                this.sliders[index].destroy();
                this.sliders[index] = undefined;
            }

            this.$$slider.forEach(($slider) => {
                const $swiperControls = $slider.querySelector('.swiper-controls');
                if ($swiperControls) {
                    $swiperControls.remove();
                }
            });
            this.slidersActive = false;
        }
    }

    initResultEvents () {
        this.$$radioFilter = this.$target.querySelectorAll('input[type="radio"]:not([data-assets-search-sidebar-filter])');
        this.$$sidebarFilter = this.$target.querySelectorAll('[data-assets-search-sidebar-filter]');
        this.$results = this.$target.querySelector('[data-asset-search="results"]');
        this.$$addToBaskets = this.$results.querySelectorAll('[data-asset-search-basket="add"]');
        this.$$categoryHeadlines = this.$results.querySelectorAll('[data-asset-search-anchor]');
        this.$sidebar = this.$target.querySelector('[data-asset-search-sidebar]');
        this.$$slider = this.$results.querySelectorAll('[data-asset-search="slider"]');
        this.sliders = [];

        this.checkSidebarPositions();

        this.$$radioFilter.forEach((radio) => {
            radio.addEventListener('change', () => {
                if (radio.getAttribute('data-asset-search') === 'prefilter') {
                    this.$activePreFilter = radio;

                    this.checkFilter(radio, () => {
                        this.filterSubmit();
                    });
                } else {
                    this.checkFilter(radio, () => {
                        this.filterSubmit();
                    });
                }
            });

            radio.addEventListener('click', () => {
                if (radio.getAttribute('data-asset-search') === 'prefilter' && radio.checked === true) {
                    this.$activePreFilter = radio;
                }
            });
        });

        this.createSlider();

        this.$$sidebarFilter.forEach((filter) => {
            filter.addEventListener('click', () => {
                const id = filter.getAttribute('data-assets-search-sidebar-filter');
                const $target = this.$results.querySelector('[data-asset-search-anchor="' + id + '"]');
                this.scrollResultsTo($target);
            });
        });

        if (this.$$addToBaskets.length > 0) {
            this.$$addToBaskets.forEach((addToBasket) => {
                addToBasket.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.sendToBasket(addToBasket.href);
                });
            });
        }
    }

    sendToBasket (url) {
        const formData = new FormData();
        const localBasket = localStorage.getItem('basket');

        if (localBasket) {
            const localBasketObject = JSON.parse(localStorage.getItem('basket'));

            if (localBasketObject.length > 0) {
                formData.append('public_items', localBasket.toString());
            }
        }

        new AjaxLoader(url, { // eslint-disable-line
            requestMethod: 'POST',
            requestData: formData,
            onSuccess: (resultText) => {
                const results = JSON.parse(resultText);
                if (results.success) {
                    this.$addToBasketInput.checked = true;
                    this.$toBasketInput.removeAttribute('data-basket-empty');
                    this.$toBasketInput.setAttribute('data-basket-not-empty', '');

                    if (results.public_items !== null) {
                        this.storage().check(results.public_items);
                    }

                    setTimeout(() => {
                        if (this.$addToBasketInput.checked === true) {
                            this.$addToBasketInput.checked = false;
                        }
                    }, 7000);
                } else {
                    console.log(results.message);
                }
            }
        });
    }

    checkFilter (radio, callback) {
        const $ownCategory = radio.closest('[data-asset-search-category]');
        const number = parseInt($ownCategory.getAttribute('data-asset-search-category')) + 1;

        for (let index = number; index <= this.maxCategories; index++) {
            const $category = this.$assetSearch.querySelector('[data-asset-search-category="' + index + '"]');

            if ($category) {
                $category.querySelectorAll('input').forEach((input) => {
                    input.setAttribute('disabled', 'disabled');
                });
            }
        }

        if (typeof callback === 'function') {
            callback();
        }
    }

    scrollResultsTo ($target) {
        const scrollPosition = getOffset($target).top; // not correct position sometimes
        const headerHeight = this.$siteHeader.clientHeight + this.$assetSearchSearch.clientHeight + 40;

        smoothScrollTo(0, scrollPosition - headerHeight, 200);
    }

    initObserver () {
        const handleIntersect = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const id = entry.target.getAttribute('data-asset-search-anchor');
                    const $sidebarInput = this.$sidebar.querySelector('[data-assets-search-sidebar-filter="' + id + '"]');
                    if ($sidebarInput) {
                        $sidebarInput.checked = true;

                        if (window.innerWidth < 1024) {
                            this.changeScrollerPosition(this.$sidebarScroller, $sidebarInput);
                        }
                    }
                }
            });
        };

        this.headlineObserver = new IntersectionObserver(handleIntersect, {
            threshold: 1
        });
    }

    checkSidebarPositions () {
        if (this.$activePreFilter) {
            if (this.$activePreFilter.value === 'products') {
                if (this.$sidebarToggleButton) {
                    this.$sidebarToggleButton.classList.remove('is--active');
                }

                this.$sidebar.classList.remove('is--category');
                this.initObserver();

                this.$$categoryHeadlines.forEach((headline) => {
                    this.headlineObserver.observe(headline);
                });
            } else {
                if (this.$sidebarToggleButton) {
                    this.$sidebarToggleButton.classList.add('is--active');
                }

                this.$sidebar.classList.add('is--category');
            }
        }
    }

    // set document history and replace actual url with new get parameters
    setHistory () {
        history.pushState(null, null, window.location.href.split('?')[0] + '?' + serializeForm(this.$form));
    }

    setCategoryFilter (categories) {
        for (let index = 1; index <= 4; index++) {
            this.$topContent.querySelector('[data-asset-search-category="' + index + '"]')?.remove();
        }

        Object.values(categories).forEach((category) => {
            if (category !== null) {
                const $newFilter = createElementFromHTML(category);
                this.$topContent.appendChild($newFilter);
            }
        });
    }

    checkForZoom ($element) {
        const $$imageZooms = $element.querySelectorAll('[data-imagezoom="root"]');

        if ($$imageZooms.length > 0) {
            import('../../components/image/image-zoom').then(({ ImageZoom }) => {
                for (let i = 0; i < $$imageZooms.length; i++) {
                    const $imageZoom = $$imageZooms[i];
                    const imageZoomAPI = new ImageZoom($imageZoom, {
                        loader: window.OPTIONS.loader
                    });

                    $imageZoom.API = imageZoomAPI;
                }
            });
        }
    }

    // get result HTML and put it into Target
    setResults (html) {
        if (html !== null) {
            const $results = createElementFromHTML(html);
            this.resultsTarget.innerHTML = '';

            if ($results.length > 1) {
                $results.forEach((element) => {
                    this.resultsTarget.appendChild(element);
                    this.checkForZoom(element);
                });
            } else {
                this.resultsTarget.appendChild($results);
                this.checkForZoom($results);
            }
        } else {
            this.resultsTarget.innerHTML = '';
        }
    }

    // get sidebar HTML and put it into sidebar
    setSidebar (html) {
        if (html !== null) {
            const $sidebarFilter = createElementFromHTML(html);
            this.$sidebar.firstElementChild.innerHTML = '';
            this.$sidebar.firstElementChild.appendChild($sidebarFilter);
        } else {
            this.$sidebar.firstElementChild.innerHTML = '';
        }
    }

    // handle the ajax request if filter has changed
    filterSubmit () {
        if (this.allowSubmit) {
            this.allowSubmit = false;

            this.$results.classList.add('is--loading');

            const formData = new FormData(this.$form);
            formData.delete('query');

            this.result = new AjaxLoader(this.$form.getAttribute('action') + '?' + serializeForm(this.$form), {
                requestMethod: this.$form.getAttribute('method'),
                requestData: formData,
                onSuccess: (resultText) => {
                    const results = JSON.parse(resultText);

                    this.setCategoryFilter(results.filter.html);
                    this.setResults(results.results.html);
                    this.setSidebar(results.sidebar.html);

                    this.initResultEvents();
                    this.initCatFilterScroller();
                    this.setScrollerEvents();
                    this.setHistory();

                    this.$results.classList.remove('is--loading');
                    this.allowSubmit = true;
                },
                onError: (error) => {
                    console.warn(error);
                }
            });
        }
    }

    storage () {
        const get = () => {
            this.localBasket = JSON.parse(localStorage.getItem('basket'));
            if (!this.localBasket) {
                this.storage().set();
            }
        };

        const set = (item) => {
            if (item) {
                const $items = JSON.parse(localStorage.getItem('basket')) || [];

                $items.push(item);
                localStorage.setItem('basket', JSON.stringify($items));
            } else {
                localStorage.removeItem('basket');
            }
        };

        const check = (newItems) => {
            this.storage().get();

            const $items = this.localBasket;
            if (this.localBasket !== null) {
                let found = false;

                for (const newItem of newItems) {
                    for (const item of $items) {
                        if (item.id === newItem.id && item.type === newItem.type) {
                            found = true;
                            break;
                        }
                    }

                    if (!found) {
                        this.storage().set(newItem);
                    } else {
                        found = false;
                    }
                }
            } else {
                for (const newItem of newItems) {
                    this.storage().set(newItem);
                }
            }
        };

        return {
            get,
            set,
            check
        };
    }
}

export { AssetSearch };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $assetSearch = $context.querySelector('[data-asset-search="root"]');

        if ($assetSearch) {
            const $assets = new AssetSearch($assetSearch);
            $assets.initialize();
        }
    }
});
